// extracted by mini-css-extract-plugin
export default {"modalOverlay":"AP-z","modalContent":"BP-z","header":"CP-z","close":"DP-z"};